import React from 'react';
import { RadialChart, Hint } from 'react-vis';
import common from 'constants/common';
import { ModuleType } from 'infrastructure/enums';

import { useFulfillmentData } from '../hooks/use-fulfillment-data';

import type { FC } from 'react';
import type {
  StatusBlocks,
  TCcmKey,
  TRpmKey,
} from '../hooks/use-fulfillment-data';

interface FulfillmentTypeChartProps {
  statusBlocks?: StatusBlocks;
  module: ModuleType;
}

const FulfillmentTypeChart: FC<FulfillmentTypeChartProps> = ({
  statusBlocks,
  module,
}) => {
  const {
    chartData,
    keys,
    disabledKeys,
    setDisabledKeys,
    hintState,
    setHintState,
  } = useFulfillmentData(module, statusBlocks);
  const getColorByKey = (key: TCcmKey | TRpmKey, m: ModuleType) => {
    if (m === ModuleType.RPM && key in common.statusNames)
      return common.statusNames[key as TRpmKey]?.color;
    if (m === ModuleType.CCM && key in common.ccmStatusNames)
      return common.ccmStatusNames[key as TCcmKey]?.color;
  };

  const getLabelByKey = (key: TCcmKey | TRpmKey, m: ModuleType) => {
    if (m === ModuleType.RPM && key in common.statusNames)
      return common.statusNames[key as TRpmKey]?.label;
    if (m === ModuleType.CCM && key in common.ccmStatusNames)
      return common.ccmStatusNames[key as TCcmKey]?.label;
  };

  return (
    <div className="onboarding-chart">
      <RadialChart
        className="radial-chart-with-hover"
        data={chartData}
        width={220}
        height={220}
        colorType="literal"
        onValueMouseOver={({ value }) => {
          setHintState({ show: true, value });
        }}
        onValueMouseOut={() => {
          setHintState({ show: false, value: {} });
        }}
      >
        {hintState.show && <Hint value={hintState.value} />}
      </RadialChart>
      <div className="onboarding-chart-legend">
        {keys.map((key) => (
          <div
            key={key}
            className="onboarding-chart-legend-item"
            style={{
              cursor: 'pointer',
              textDecoration: disabledKeys.includes(key)
                ? 'line-through'
                : 'none',
            }}
            onClick={() => {
              if (disabledKeys.includes(key)) {
                setDisabledKeys(disabledKeys.filter((item) => item !== key));
              } else {
                setDisabledKeys([...disabledKeys, key]);
              }
            }}
          >
            <div
              style={{ backgroundColor: getColorByKey(key, module) }}
              className="onboarding-chart-legend-item-dot"
            />
            <div className="onboarding-chart-legend-item-title">
              {getLabelByKey(key, module)}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FulfillmentTypeChart;
